import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRoutingModule } from './dashboard.routing';
import { DasboardTabLayoutComponent } from './components/dasboard-tab-layout/dasboard-tab-layout.component';
import { SearchEngineModule } from '../search-engine/search-engine.module';
import { HomeHeadingContianerComponent } from './components/home-heading-contianer/home-heading-contianer.component';
import { MyTripsComponent } from './components/my-trips/my-trips.component';
import { MatButtonModule } from '@angular/material/button';
import { TravelComfortComponent } from './components/travel-comfort/travel-comfort.component';
import { MatIconModule } from '@angular/material/icon';
import { ProfileStripSummaryComponent } from './components/profile-strip-summary/profile-strip-summary.component';
import { MulticityDashboardTabLayoutComponent } from './components/multicity-dashboard-tab-layout/multicity-dashboard-tab-layout.component';
import { UpcomingTripEmptyComponent } from './components/upcoming-trip-empty/upcoming-trip-empty.component';
import { UpcomingTripListingComponent } from './components/upcoming-trip-listing/upcoming-trip-listing.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { SharedModule } from "src/app/shared/shared.module";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';



@NgModule({
    imports: [
        CommonModule,
        DashboardRoutingModule,
        SearchEngineModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,
        MatTabsModule,
        MatFormFieldModule,
        MatSelectModule,
        SharedModule,
        MatCheckboxModule,
        FormsModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MatExpansionModule,
        DasboardTabLayoutComponent,
        HomeHeadingContianerComponent,
        MyTripsComponent,
        TravelComfortComponent,
        ProfileStripSummaryComponent,
        MulticityDashboardTabLayoutComponent,
        UpcomingTripEmptyComponent,
        UpcomingTripListingComponent,
    ]
})
export class DashboardModule { }
